import { useMemo } from 'react';

import { getQueryStringParams } from '../../utils/getQueryStringParams';

/**
 * Parses the search query part of location and return an object containing the params.
 * NOTE: keep in mind that this will read the current window.location
 */
function useQueryParams<T extends string>() {
  return useMemo(() => getQueryStringParams<T>(), []);
}

export { useQueryParams };
